<template>
	<div>
		<div class="subviewOpts">
			<it-link :to="createProductCustomerLink" class="button-link button-link-bicon">
				<sym-icon name="box-open"></sym-icon> {{ env.msg('menu.createProductCustomer') }}
			</it-link>
			<it-link :to="filterCustomersObjectsLink" class="button-link button-link-bicon">
				<sym-icon name="filter"></sym-icon> {{ env.msg('menu.viewObjectsInAgenda') }}
			</it-link>
		</div>
		<div>
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import {injectEnv} from "@fd/Environment.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import {addContextParams, ContextKey, getIntValue, injectContext} from "@t/fd/AppContext.ts";
import {SrcType} from "@t/meta/SourceType.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const party = computed<number>(() => {
	if (sourceType.value === SrcType.PARTY) {
		let idValue = sourceId.value;
		return typeof idValue === "number" ? idValue : parseInt(idValue);
	}
	if (hasValue(ctx.value, ContextKey.PERSON)) return getIntValue(ctx.value, ContextKey.PERSON);
	if (hasValue(ctx.value, ContextKey.BRANCH)) return getIntValue(ctx.value, ContextKey.BRANCH);
	if (hasValue(ctx.value, ContextKey.CUSTOMER)) return getIntValue(ctx.value, ContextKey.CUSTOMER);
	return 0;
});

const createProductCustomerLink = computed<string>(() => {
	return env.net.urlParam("createProductCustomer.do", "customer", party.value);
});

const filterCustomersObjectsLink = computed<string>(() => {
	let link = env.net.urlParam("filterCustomersObjects.do", "obj", "productcustomers");
	link = env.net.urlParam(link, "customer", party.value);
	return link;
});

const restApi = computed<string>(() => {
	let ep = "api/productcustomers/agendaSubview";
	ep = env.net.urlParam(ep, "customer", sourceId.value);
	return ep;
});

</script>

<style>

</style>